import { SharedModule } from "@app/shared/shared.module";
import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  RouterLink,
  RouterLinkActive,
  RouterModule,
  RouterOutlet,
} from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from "@angular/common/http";
import { DashboardHomeComponent } from "./dashboards/home/dashboard-home.component";
import { AppComponent } from "./app/app.component";
import { CoreModule } from "./core/core.module";
import { SecurityModule } from "./security/security.module";
import { MessageBoxComponent } from "./shared/messagebox/messagebox.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { UnAuthorizedAccessComponent } from "./account/unauthorized/unauthorizes-access.component";
import { LoaderComponent } from "./shared/danphe-loader-intercepter/danphe-loader";
import { ActivateInventoryComponent } from "./shared/activate-inventory/activate-inventory.component";
import { AppRoutingModule } from "./app.routes";
import { CommonModule, registerLocaleData } from "@angular/common";
import { GlobalLoaderComponent } from "./shared/Components/shared/Components/global-loader/global-loader.component";
import { LoadingInterceptor } from "./shared/services/loading.interceptor";
import { AccBusyInterceptor } from "./accounting/core/busy/acc-busy.interceptor";
import { AuthGuard } from "./security/utilities/auth.guard";
import { AuthInterceptor } from "./security/utilities/auth.interceptor";
import { LoginComponent } from "./account/login/login.component";
import { AppLayoutComponent } from "./layouts/app/app-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { AppInitializationService } from "./security/utilities/app-initialization.service";
import { MatDialogModule } from "@angular/material/dialog";
import { MasterDataCache } from "./shared/danphe-cache-service-utility/cache-services";
import { SecurityService } from "./security/shared/security.service";
import { SharedInjector } from "./shared/utilities/shared.injector";
import { CacheService } from "./shared/utilities/cache.service";
import { TempReloadComponent } from "./dashboards/temp-reload/temp-reload.component";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';
import { UnderDevelopmentComponent } from "./under-development/under-development.component";
import { UnderDevelopmentActionsComponent } from "./under-development/under-development-actions.component";
import { UnderDevelopmentChecksComponent } from "./under-development/under-development-checks.component";
import { UnderDevelopmentIllustrationComponent } from "./under-development/under-development-illustration.component";
import { UnderDevelopmentStatusComponent } from "./under-development/under-development-status.component";
import { InsuredPatientAdmissionRequestModule } from "./adt/admission/insured-patient-admission-request/insured-patient-admission-request.module";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "/assets/i18n/", ".json");
}
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeEn, 'en');
export function localeFactory() {
  return localStorage.getItem("lang") === "ar" ? "ar" : "en";
}
@NgModule({
  providers: [
    AuthGuard,
    AppInitializationService,
    MessageService,

    { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AccBusyInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: LOCALE_ID,
      useFactory: localeFactory,
    },
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    RouterOutlet,
    CommonModule,
    RouterLink,
    RouterLinkActive,
    AppRoutingModule,
    // SharedModule,
    // NotesModule,
    HttpClientModule,
    CoreModule,
    SecurityModule,
    SharedModule,
    InsuredPatientAdmissionRequestModule,
    MatDialogModule,
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    AppComponent,
    MessageBoxComponent,
    DashboardHomeComponent,
    UnAuthorizedAccessComponent,
    LoginComponent,
    LoaderComponent,
    ActivateInventoryComponent,
    GlobalLoaderComponent,
    AppLayoutComponent,
    AuthLayoutComponent,
    TempReloadComponent,
    UnderDevelopmentComponent,
    UnderDevelopmentActionsComponent,
    UnderDevelopmentChecksComponent,
    UnderDevelopmentIllustrationComponent,
    UnderDevelopmentStatusComponent
  ],
  exports: [RouterModule],
  bootstrap: [AppComponent],
})
export class AppModule {
  // these services needs to be initialized once on startup
  constructor(
    private readonly cacheService: CacheService,
    private readonly securityService: SecurityService,
    private readonly masterCacheService: MasterDataCache,
    private readonly sharedInjector: SharedInjector,
  ) {}
}
